var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('goods-tabbar',{ref:"tabbar",attrs:{"durations":_vm.durations},on:{"tabbar-click":_vm.onTabbarClick}}),_c('goods-tab-content',{ref:"tabContent",attrs:{"durations":_vm.durations,"activeDuration":_vm.activeDuration,"currentDuration":_vm.currentDuration}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }